import {css} from "@emotion/react";


const styles = {
    carousel: css`
        .selected {
            transition: 0.5s ease-in;
            > div:first-of-type {
                transition: 0.5s ease-in;
                height: 786px;
                box-shadow: 0 -4px 23px 1px #6F41D280 inset;
                border: 3px solid #5834A8;
                background-color: #080411;
                border-radius: 24px;

                button {
                    background-color: #5834A8;
                }
            }
        }

        .slider {
            align-items: center;
        }

    `,
    carouselComments: css`
        .slick-list {
            padding: 50px 0 !important;
        }

    `,
    carouselSubs: css`
        .slick-current {
            .child {
                background: #080411;
                box-shadow: 0px -4.63px 23.13px 1.16px #6F41D280 inset;
                h2{
                    background: linear-gradient(90.01deg, #E59CFF 0.01%, #BA9CFF 50.01%, #9CB2FF 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    text-fill-color: transparent;
                }
                button{
                    background: rgba(88, 52, 168, 1);
                    color: #fff;
                }
            }
        }

        .slick-list {
            padding: 80px 0 !important;
        }

    `
}

export default styles